import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-config-card',
  templateUrl: './turns-config-card.component.html',
  styleUrls: ['./turns-config-card.component.scss']
})
export class TurnsConfigCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
